const submitAnswer = /* GraphQL */ `
  mutation SubmitAnAnswer(
    $pageId: String!
    $questionId: String!
    $answerText: String!
    $authorName: String!
    $authorLocation: String!
    $email: String!
  ) {
    submitAnAnswer(
      pageId: $pageId
      questionId: $questionId
      answerText: $answerText
      authorName: $authorName
      authorLocation: $authorLocation
      email: $email
    )
  }
`

export default submitAnswer
